import { render, staticRenderFns } from "./EditPrimaryContentDialog.vue?vue&type=template&id=fea94058&"
import script from "./EditPrimaryContentDialog.vue?vue&type=script&lang=ts&"
export * from "./EditPrimaryContentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
